import { Check, Copy } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

// Sub-paths, not the barrels: those drag the legacy coreOld graph into every grid test.
import { Button } from 'core/components/Button';
import { useCopyToClipboard } from 'core/hooks/useCopyToClipboard';
import { Color, Variant } from 'theme/enums';

interface IProps {
  value: string;
  label: string;
}

// In a grid cell the column must opt its clicks out of row selection (suppressMouseEventHandling).
export const CopyValueButton = ({ value, label }: IProps) => {
  const { t } = useTranslation();

  const { isCopied, copy } = useCopyToClipboard();

  const copyLabel = isCopied ? t('buttonLabelCopied') : label;

  return (
    <Button
      icon={isCopied ? <Check /> : <Copy />}
      variant={Variant.PLAIN}
      color={isCopied ? Color.SUCCESS : Color.NEUTRAL}
      aria-label={copyLabel}
      onClick={() => copy(value)}
      tooltipProps={{ title: copyLabel, children: null }}
    />
  );
};
